import React, { useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { InstagramOutlined, FireOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import logo from '../images/logo.png';
import { useUser } from '../context/UserContext'; // Importa il contesto utente

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
  padding-top: 50px;
  border-bottom: 1px solid rgba(255, 0, 0, 0.3);
  background-color: rgba(255, 255, 255, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  /* Nascondi l'header sui desktop (larghezza > 768px) */
  @media (min-width: 769px) {
    display: none;
  }
`;

const Logo = styled.img`
  height: 50px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

// Il $ davanti dice a styled-components che la proprieta' serve solo allo stile
// e non va passata al componente sottostante: senza, finiva sull'elemento del
// DOM e React segnalava un avviso a ogni disegno.
const FireIcon = styled(FireOutlined)`
  color: var(--inchiostro);
  font-size: 24px;
  ${({ $shouldPulse }) =>
    $shouldPulse &&
    css`
      animation: ${pulseAnimation} 3s ease-in-out;
    `};
`;

const StyledIcon = styled.div`
  font-size: 24px;
  color: var(--inchiostro);
  cursor: pointer;

  /* L'icona resta di 24px, ma l'area da premere arriva a 44: e' il minimo
     perche' si riesca a centrarla col pollice. Prima era 24x24. */
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* Un minimo di risposta al tocco: senza, non si capisce se ha funzionato. */
  transition: opacity 150ms ease;
  &:active { opacity: 0.6; }
`;

const AppHeader = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [shouldPulse, setShouldPulse] = useState(false);

  useEffect(() => {
    if (user?.role === 'cliente') {
      // Imposta shouldPulse a true per far partire l'animazione
      setShouldPulse(true);

      // Dopo 4 secondi, ferma l'animazione
      const timer = setTimeout(() => {
        setShouldPulse(false);
      }, 4000);

      // Pulizia del timer quando il componente viene smontato
      return () => clearTimeout(timer);
    }
  }, [user]);

  useEffect(() => {
    if (shouldPulse) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    };
  }, [shouldPulse]);

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/fit_e_lab/', '_blank');
  };

  const handleDailyClick = () => {
    navigate('/daily-workout');
  };

  return (
    <HeaderContainer>
      <Logo src={logo} alt="Fit&Lab Logo" />
      <ButtonContainer>
        <StyledIcon onClick={handleInstagramClick}>
          <InstagramOutlined />
        </StyledIcon>
        <StyledIcon onClick={handleDailyClick}>
          <FireIcon $shouldPulse={shouldPulse} />
        </StyledIcon>
      </ButtonContainer>
    </HeaderContainer>
  );
};

export default AppHeader;
